export const SET_FILTER_USER = "@user/SET_FILTER_USER";
export const IS_USER_EXIST = "@user/IS_USER_EXIST";
